import Cookies from 'js-cookie'

const TokenKey = 'admin-center-token'

export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token,expire) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js